import React, { createContext, useContext, useState, ReactNode } from 'react';

interface PropertyContextType {
  propertySelectedId: string;
  setPropertySelectedId: (id: string) => void;
}

const PropertyContext = createContext<PropertyContextType | undefined>(undefined);

export const PropertyProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [propertySelectedId, setPropertySelectedIdState] = useState<string>(() => {
    return localStorage.getItem('creditPropertySelected') || '';
  });

  const setPropertySelectedId = (id: string) => {
    setPropertySelectedIdState(id);
    localStorage.setItem('creditPropertySelected', id);
  };

  return (
    <PropertyContext.Provider value={{ propertySelectedId, setPropertySelectedId }}>
      {children}
    </PropertyContext.Provider>
  );
};
export const useCreditProperty = (): PropertyContextType => {
  const context = useContext(PropertyContext);
  if (!context) {
    throw new Error('useCreditProperty must be used within a PropertyProvider');
  }
  return context;
};
